import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

import { IStrapiDocument, LoadScreen } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { PageRetrievalErrorComponent } from '../../../shared/components/page-retrieval-error/page-retrieval-error.component';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-app-terms',
    templateUrl: './app-terms.component.html',
    styleUrls: ['./app-terms.component.scss'],
    imports: [
        BreadcrumbsComponent,
        NgIf,
        PageRetrievalErrorComponent,
        RenderMarkdownComponent,
    ],
})
export class AppTermsComponent implements OnInit {
  public pageData: LoadScreen = <LoadScreen>{};

  public pageRetrievalError = false;

  private cdr = inject(ChangeDetectorRef);

  constructor(
    public readonly titleService: Title,
    public readonly metaService: Meta,

    public readonly strapi: StrapiService
  ) {}

  ngOnInit(): void {
    this.strapi.getDocumentsByType('load-screen').subscribe({
      next: (data: IStrapiDocument<LoadScreen>) => {
        this.parsePageData(data.data.attributes);
        this.cdr.markForCheck();
      },
      error: () => {
        this.pageRetrievalError = true;
        this.cdr.markForCheck();
      },
    });
  }

  protected parsePageData(page: LoadScreen): void {
    this.pageData = page;
  }
}
